import React, { useState, useEffect } from "react";
import MyHeader from "./header";
import { useNavigate } from "react-router-dom";



const Login = ({ cartItems = 0, cartList = [], cartTotal = 0, showCartDropdown = false, onCartToggle = () => {}, onRemoveItem = () => {} }) => {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });


  const ORANGE_COLOR = '#1953b7ff';

  const [message, setMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const navigate = useNavigate();

  // Callback for Google sign-in
  const handleGoogleCredentialResponse = async (response) => {
    if (response.credential) {
      // Decode JWT token to get user info
      const base64Url = response.credential.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
      const userObject = JSON.parse(jsonPayload);

      // Check if user exists by email
      try {
        const checkRes = await fetch(`/check-user-email`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: userObject.email }),
        });
        const checkData = await checkRes.json();
        if (checkRes.ok && checkData.exists) {
          // User exists, login with username and password from response
          try {
            const loginRes = await fetch("/api/login", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                username: checkData.username,
                password: checkData.password,
              }),
            });
            const loginData = await loginRes.json();
            if (loginRes.ok) {
              localStorage.setItem("token", loginData.token);
              document.cookie = `name=${encodeURIComponent(loginData.name)}; path=/`;
              document.cookie = `address=${encodeURIComponent(loginData.address)}; path=/`;
              document.cookie = `email=${encodeURIComponent(loginData.email)}; path=/`;
              document.cookie = `tel1=${encodeURIComponent(loginData.tel1)}; path=/`;
              document.cookie = `tel2=${encodeURIComponent(loginData.tel2)}; path=/`;
              setMessage("Signed in successfully with Google account.");
              navigate("/");
              return;
            } else {
              setMessage(loginData.message || "Login failed");
              return;
            }
          } catch (loginError) {
            setMessage("Error connecting to server for login");
            return;
          }
        }
      } catch (error) {
        setMessage("Error checking user existence");
        return;
      }

      // User does not exist, proceed with signup

      // Generate random password
      const generateRandomPassword = (length = 12) => {
        const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+";
        let password = "";
        for (let i = 0; i < length; i++) {
          password += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return password;
      };

      const randomPassword = generateRandomPassword();

      // Prepare user data for signup
      const userData = {
        name: userObject.name || "",
        email: userObject.email || "",
        username: userObject.email ? userObject.email.split("@")[0] : "",
        password: randomPassword,
        address: "",
        tel1: "",
        tel2: "",
      };

      // Automatically create user and sign in
      try {
        const res = await fetch("/api/signup", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(userData),
        });
        const data = await res.json();
        if (res.ok) {
          // After successful signup, automatically login the user
          try {
            const loginRes = await fetch("/api/login", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                username: userData.username,
                password: userData.password,
              }),
            });
            const loginData = await loginRes.json();
            if (loginRes.ok) {
              // Save token to localStorage for keeping user signed in
              localStorage.setItem("token", loginData.token);
              // Save additional user details in cookies
              document.cookie = `name=${encodeURIComponent(loginData.name)}; path=/`;
              document.cookie = `address=${encodeURIComponent(loginData.address)}; path=/`;
              document.cookie = `email=${encodeURIComponent(loginData.email)}; path=/`;
              document.cookie = `tel1=${encodeURIComponent(loginData.tel1)}; path=/`;
              document.cookie = `tel2=${encodeURIComponent(loginData.tel2)}; path=/`;
              setMessage("Signed in successfully with Google account.");
              // Redirect to home page
              navigate("/");
            } else {
              setMessage(loginData.message || "Login failed after signup");
            }
          } catch (loginError) {
            setMessage("Error connecting to server for login after signup");
          }
        } else {
          setMessage(data.message || "Google sign-in failed");
        }
      } catch (error) {
        setMessage("Error connecting to server for Google sign-in");
      }
    }
  };

  // Load Google Identity Services script and initialize button after script loads
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;

    const onScriptLoad = () => {
      if (window.google && window.google.accounts && window.google.accounts.id) {
        window.google.accounts.id.initialize({
          client_id: "724969984336-amnn4b391tktr89m312p6q6ucreff10b.apps.googleusercontent.com", // TODO: Replace with your Google client ID
          callback: handleGoogleCredentialResponse,
        });
        window.google.accounts.id.renderButton(
          document.getElementById("googleSignInDiv"),
          { theme: "outline", size: "large" }
        );
        window.google.accounts.id.prompt(); // Show the One Tap prompt
      }
    };

    script.onload = onScriptLoad;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    try {
      const response = await fetch("/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      if (response.ok) {
        // Save token to localStorage for keeping user signed in
        localStorage.setItem("token", data.token);
        // Save additional user details in cookies
        document.cookie = `name=${encodeURIComponent(data.name)}; path=/`;
        document.cookie = `address=${encodeURIComponent(data.address)}; path=/`;
        document.cookie = `email=${encodeURIComponent(data.email)}; path=/`;
        document.cookie = `tel1=${encodeURIComponent(data.tel1)}; path=/`;
        document.cookie = `tel2=${encodeURIComponent(data.tel2)}; path=/`;
        setShowToast(true);
        setTimeout(() => {
          setShowToast(false);
          navigate("/");
        }, 3000);
      } else {
        setMessage(data.message || "Login failed");
      }
    } catch (error) {
      setMessage("Error connecting to server");
    }
  };

  return (
    <div style={{ paddingTop: '70px' }}>
      <MyHeader 
        cartItems={cartItems}
        cartList={cartList}
        cartTotal={cartTotal}
        showCartDropdown={showCartDropdown}
        onCartToggle={onCartToggle}
        onRemoveItem={onRemoveItem}
      />


      <br/><br/><br/>  <br/><br/><br/> 

      <div style={{ maxWidth: '600px', margin: '40px auto', padding: '20px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', borderRadius: '12px', backgroundColor: '#fff' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '20px', fontWeight: '700', fontSize: '2rem', color: '#333' }}>Login</h2>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
          <img 
            src="https://www.w3schools.com/howto/img_avatar2.png" 
            alt="User Avatar" 
            style={{ width: '100px', height: '100px', borderRadius: '50%', objectFit: 'cover', boxShadow: '0 2px 8px rgba(0,0,0,0.2)' }} 
          />
        </div>
        {message && <div style={{ backgroundColor: ORANGE_COLOR, color: ORANGE_COLOR, padding: '10px 15px', borderRadius: '8px', marginBottom: '15px', textAlign: 'center' }}>{message}</div>}
        {showToast && <div style={{ backgroundColor: '#d4edda', color: ORANGE_COLOR, padding: '10px 15px', borderRadius: '8px', marginBottom: '15px', textAlign: 'center' }}>Login successful!</div>}
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <label style={{ display: 'flex', flexDirection: 'column', fontWeight: '600', color: '#555' }}>
            Username:
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              style={{ padding: '10px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '1rem', marginTop: '5px' }}
            />
          </label>
          <label style={{ display: 'flex', flexDirection: 'column', fontWeight: '600', color: '#555' }}>
            Password:
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              style={{ padding: '10px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '1rem', marginTop: '5px' }}
            />
          </label>
          <button
            type="submit"
            style={{
              padding: '12px',
              borderRadius: '10px',
              border: 'none',
              backgroundColor: ORANGE_COLOR,
              color: 'white',
              fontWeight: '700',
              fontSize: '1.1rem',
              cursor: 'pointer',
              transition: 'background-color 0.3s ease',
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = ORANGE_COLOR}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = ORANGE_COLOR}
          >
            Login
          </button>
        </form>
        <div id="googleSignInDiv" style={{ marginTop: "20px", textAlign: "center", display: "none" }}></div>
      </div>
    </div>
  );
};

export default Login;
